/*global DSV, jQuery */

/**
 * DSV selfService
 */

(function($, window) {
  "use strict";

  DSV.ui.spotContent = {
    init: function(spot) {
      this.DOM = {};
      this.DOM.spot = spot;
      this.DOM.link = spot.querySelector("a.jsspotlink");

      if (this.DOM.spot && this.DOM.link) {
        this.DOM.spot.addEventListener("click", function(e) {
          var href = e.currentTarget.querySelector("a").getAttribute("href");
          var target = e.currentTarget
            .querySelector("a")
            .getAttribute("target");
          if (target && target === "_blank") {
            window.open(href);
          } else {
            window.location.href = href;
          }
        });
      }
    },
  };
})(jQuery, window);
